import { CLEAR_SELECTED_UPSELLS, SET_UPSELL_OPTIONS, TOGGLE_UPSELL } from '@store/actions';
import { IUpsell, UpsellType } from '@types';

export interface ISetUpsellOptionsAction {
    type: 'SET_UPSELL_OPTIONS';
    payload: IUpsell[];
}

export interface IToggleUpsellAction {
    type: 'TOGGLE_UPSELL';
    payload: UpsellType;
}

export interface IClearSelectedUpsellsAction {
    type: 'CLEAR_SELECTED_UPSELLS';
    payload: null;
}

export type UpsellAction = ISetUpsellOptionsAction | IToggleUpsellAction | IClearSelectedUpsellsAction;

export const setUpsellOptionsAction = (data: IUpsell[]): ISetUpsellOptionsAction => ({
    type: SET_UPSELL_OPTIONS,
    payload: data,
});

export const toggleUpsellAction = (data: UpsellType): IToggleUpsellAction => ({ type: TOGGLE_UPSELL, payload: data });

export const clearSelectedUpsellsAction = (): IClearSelectedUpsellsAction => ({
    type: CLEAR_SELECTED_UPSELLS,
    payload: null,
});
